module.exports = "/fonts/fa-brands-400.woff?9f018d1025561e96439f7c0e9026301a";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/styles/fontawesome/webfonts/fa-brands-400.woff
// module id = SyuQ
// module chunks = 0 1